import { createContext, useContext } from 'react';

const NtaExamSummaryContext = createContext(null);

export const NtaExamSummaryProvider = NtaExamSummaryContext.Provider;

export const useNtaExamSummary = () => useContext(NtaExamSummaryContext);
